import React from 'react';
import { Router } from '@reach/router';
import Layout from '../components/layout';
import Body from '../components/icare/Body';

const headerText = 'iCARE';

const iCARE = () => {
  return (
    <Layout headerText={headerText} heroBg="grass">
      <Router>
        <Body path="/icare" />
      </Router>
    </Layout>
  );
};

export default iCARE;
